import { createFeatureSelector, createSelector } from '@ngrx/store';

import { PackagesState } from '../states/packages.state';

export const selectPackagesState$ = createFeatureSelector<PackagesState>('packages');

export const selectCurrentOrganizationId$ = createSelector(selectPackagesState$, state => state.currentOrganizationId);

export const selectOrganizations$ = createSelector(selectPackagesState$, state => state.organizations);

export const selectSelectedPackageIds = createSelector(selectPackagesState$, state => state.selectedPackageIds);

export const selectAllPackages$ = createSelector(selectPackagesState$, state => {
    const orgId = state.currentOrganizationId;
    const org = state.organizations.entities[orgId];
    return org ? org.packages.ids.map(id => org.packages.entities[id]) : [];
});

export const selectPackageById$ = (id: string) =>
    createSelector(selectPackagesState$, state => {
        const org = state.organizations.entities[state.currentOrganizationId];
        return org?.packages.entities[id];
    });

export const getPackagesByFilters$ = createSelector(selectPackagesState$, state => {
    const orgId = state.currentOrganizationId;
    const org = state.organizations.entities[orgId];
    const searchText = state.searchText?.toLowerCase() || '';

    if (!org) return [];

    const packages = org.packages.ids
        .map(id => org.packages.entities[id])
        .filter(pkg => {
            const name = pkg?.displayName?.toLowerCase() || '';
            return name.includes(searchText);
        })
        .sort((a, b) => {
            const nameA = a?.displayName?.toLowerCase() || '';
            const nameB = b?.displayName?.toLowerCase() || '';
            return nameA.localeCompare(nameB);
        });

    return packages;
});
